export const filter_config = (mailbox_options) => ({
  title: 'Transactional email filters',
  filters: [
    { label: 'Sender email', value: mailbox_options, key: 'sender_email', type: 'multichoice' },
    { value: 'created_on', label: 'Date created', key: 'created_on', type: 'range' }
  ]
});
